<template>
  <global-modal :active="active" @toggleActive="toggleActive">
    <section class="text-xl font-medium" slot="header">Suka</section>
    <div class="flex p-5 justify-center" v-if="likes.length <= 0">
      Belum ada yang menyukai komentar ini
    </div>
    <div class="w-full" v-else>
      <div class="w-full m-3" v-for="(item, index) in likes" :key="index">
        <global-user
          :name="item.pengguna.nama"
          :subname="item.pengguna.jabatan.nama"
        ></global-user>
      </div>
    </div>
  </global-modal>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean
    },
    likes: {
      type: Array
    }
  },
  methods: {
    toggleActive(bol) {
      this.$emit("toggleActive", bol);
    }
  }
};
</script>
